/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable prettier/prettier */
import moment from 'moment';
import FacebookLogo from '../../assets/facebook.png';
import InstagramLogo from '../../assets/instagram.png';
import LinkedinLogo from '../../assets/linkedin.png';
import TwitterLogo from '../../assets/twitter.png';

/* PLATFORM PROPS */
export interface IPlatformProps {
    name: string;
    logo: string;
    color: string;
}

const Facebook: IPlatformProps = {
    name: 'Facebook',
    logo: FacebookLogo,
    color: '#217BEE',
};

const Linkedin: IPlatformProps = {
    name: 'Linkedin',
    logo: LinkedinLogo,
    color: '#0A66C2',
};

const Twitter: IPlatformProps = {
    name: 'Twitter',
    logo: TwitterLogo,
    color: '#1DA1F2',
};

const Instagram: IPlatformProps = {
    name: 'Instagram',
    logo: InstagramLogo,
    color: '#E4405F',
};

const PLATFORM: { [key: string]: IPlatformProps } = {
    FACEBOOK: Facebook,
    LINKEDIN: Linkedin,
    INSTAGRAM: Instagram,
    TWITTER: Twitter,
};

/* SERVICE PROPS */
export interface IServiceProps {
    name: string;
    color: string;
}

const facebook: IServiceProps = {
    name: 'Facebook',
    color: '#217BEE',
};

const instagram: IServiceProps = {
    name: 'Instagram',
    color: '#E4405F',
};

const linkedin: IServiceProps = {
    name: 'Linkedin',
    color: '#0A66C2',
};

const twitter: IServiceProps = {
    name: 'Twitter',
    color: '#1DA1F2',
};

const SERVICES: { [key: string]: IServiceProps } = {
    FACEBOOK: facebook,
    INSTAGRAM: instagram,
    LINKEDIN: linkedin,
    TWITTER: twitter,
};

export interface IEventsCalendar extends Partial<IServiceProps> {
    id?: number;
    start?: Date;
    end?: Date;
    title?: string;
    platform?: IPlatformProps;
    [key: string]: any;
}

const posts: IEventsCalendar[] = [
    {
        id: 0,
        start: moment().startOf('month').startOf('day').add(9, 'hour').toDate(),
        end: moment().startOf('month').startOf('day').add(9, 'hour').toDate(),
        title: 'Facebook Post',
        platform: PLATFORM.FACEBOOK,
        ...SERVICES.FACEBOOK,
    },
    {
        id: 1,
        start: moment().startOf('month').add(1, 'day').startOf('day').add(9, 'hour').toDate(),
        end: moment().startOf('month').add(1, 'day').startOf('day').add(9, 'hour').toDate(),
        title: 'Instagram Post',
        platform: PLATFORM.INSTAGRAM,
        ...SERVICES.INSTAGRAM,
    },
    {
        id: 2,
        start: moment().startOf('month').add(2, 'day').startOf('day').add(9, 'hour').toDate(),
        end: moment().startOf('month').add(2, 'day').startOf('day').add(9, 'hour').toDate(),
        title: 'Twitter Post',
        platform: PLATFORM.TWITTER,
        ...SERVICES.TWITTER,
    },
    {
        id: 3,
        start: moment().startOf('month').add(3, 'day').startOf('day').add(9, 'hour').toDate(),
        end: moment().startOf('month').add(3, 'day').startOf('day').add(9, 'hour').toDate(),
        title: 'Linkedin Post',
        platform: PLATFORM.LINKEDIN,
        ...SERVICES.LINKEDIN,
    },
    {
        id: 4,
        start: moment().add(1, 'day').startOf('day').add(10, 'hour').toDate(),
        end: moment().add(1, 'day').startOf('day').add(10, 'hour').toDate(),
        title: 'This is tommorow\'s post',
        platform: PLATFORM.FACEBOOK,
        ...SERVICES.FACEBOOK,
    },
    {
        id: 5,
        start: moment().add(1, 'day').startOf('day').add(11, 'hour').toDate(),
        end: moment().add(1, 'day').startOf('day').add(11, 'hour').toDate(),
        title: 'This is tommorow\'s post',
        platform: PLATFORM.INSTAGRAM,
        ...SERVICES.INSTAGRAM,
    },
    {
        id: 4,
        start: moment().add(1, 'day').startOf('day').add(12, 'hour').toDate(),
        end: moment().add(1, 'day').startOf('day').add(12, 'hour').toDate(),
        title: 'This is tommorow\'s post',
        platform: PLATFORM.LINKEDIN,
        ...SERVICES.LINKEDIN,
    },
    {
        id: 4,
        start: moment().add(1, 'day').startOf('day').add(1, 'hour').toDate(),
        end: moment().add(1, 'day').startOf('day').add(1, 'hour').toDate(),
        title: 'This is tommorow\'s post',
        platform: PLATFORM.TWITTER,
        ...SERVICES.TWITTER,
    },
];

export default posts;
